export default __webpack_public_path__ + "static/media/carousel-placeholder1.9e3bafa8.gif";